<template lang="pug">
  div.access.backups
    e-toolbar(
    :items="items"
    :hideRemoveButton="true"
    :showCol="false"
    :showViewPanel="false"
    :showTotal="true"
    :hideImportBtn="true"
    :hideAddButton="true"
    :hideSearch="true"
    )
      div(slot="additionalActions")
        button(
         v-if="userCanCreate"
         @click.stop.prevent="createBackup()"
        ) Сохранить текущее состояние
    e-table(
    :items="items"
    :showCheckbox="false"
    :actionColumnWidth="200"
    )
      div(slot="actionButtons" slot-scope="props").actions.is-center
        button(
        :disabled="!props.row.url"
        @click.stop.prevent="viewBackup(props.row)"
        ) Просмотр состояния

    router-view
</template>

<script>
  import {snapshot} from '../../api/api-endpoints.js'
  import tableMixin from "../../components/table/table-mixin.js"
  import permissionMixin from '../../mixins/permission-mixin.js'

  export default {
    mixins: [tableMixin, permissionMixin],
    data () {
      return {
        bckpBegin: false
      }
    },
    methods: {
      getEndpoint (route, _) {
        return snapshot.snapshots(route)
      },
      createBackup () {
        if (this.bckpBegin === true) {
          return
        }
        this.bckpBegin = true
        this.$bar.start()
        this.$store.dispatch('createModel', {
          url: snapshot.snapshotCreate()
        }).then(() => {
          this.bckpBegin = false
          this.reFetchData()
        }).catch(e => {
          this.bckpBegin = false
          this.$bar.finish()
          this.$e.errorBox(e)
        })
      },
      viewBackup (item) {
        if (!item.url) {
          return
        }
        let [scheme] = window.location.origin.split('://')
        window.open(`${scheme}://${item.url}`, '_blank')
      }
    }
  }
</script>
